<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->

    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <patients-table title="Patients" :data="patients"></patients-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PatientsTable from "./Tables/PatientsTable";
export default {
  name: "tables",
  components: {
    PatientsTable,
  },
  data() {
    return {
      patients: [],
    };
  },
  methods: {
    async getPatients() {
      this.patients = await this.$store.dispatch("admin/getPatients");
    },
  },
  mounted() {
    this.getPatients();
  },
};
</script>
<style></style>
